import hireGuide from "./hire-private-assistant-france-guide";
import vsConcierge from "./private-assistant-vs-concierge";
import costNoSupport from "./cost-of-no-support-france";
import executiveSupport from "./executive-support-international-leaders";
import settingUpBusiness from "./setting-up-business-france-administrative-reality";
import adminDecoded from "./french-administration-decoded";
import parisFamilies from "./paris-international-families";
import trustedPerson from "./trusted-person-every-country";
import discretionStandard from "./discretion-standard-ndas-privacy";
import first30Days from "./first-30-days-france";
import septemberReset from "./what-to-delegate-personal-assistant-paris";
import costPrices from "./personal-assistant-paris-cost-prices";
import americanClients from "./what-american-clients-delegate";
import chineseClients from "./what-chinese-clients-delegate";
import brazilianClients from "./what-brazilian-clients-delegate";
import airportsGuide from "./paris-airports-cdg-orly-le-bourget-guide";
import luxuryExperiences from "./luxury-experiences-paris-international-visitors";
import businessTravel from "./business-travel-concierge-paris-how-it-works";
import twentyFourHours from "./24-hours-in-paris-what-to-delegate";
import conciergeCost from "./private-concierge-cost-paris";
import conciergeVsHotel from "./private-concierge-vs-hotel-concierge-paris";
import lastMinuteTables from "./last-minute-restaurant-reservations-paris";
import privateShopping from "./private-shopping-paris-how-it-works";

export const ARTICLES = [
  airportsGuide,
  luxuryExperiences,
  businessTravel,
  twentyFourHours,
  conciergeCost,
  conciergeVsHotel,
  lastMinuteTables,
  privateShopping,
  americanClients,
  chineseClients,
  brazilianClients,
  costPrices,
  septemberReset,
  hireGuide,
  vsConcierge,
  costNoSupport,
  executiveSupport,
  settingUpBusiness,
  adminDecoded,
  parisFamilies,
  trustedPerson,
  discretionStandard,
  first30Days,
];

export const getArticle = (slug) => ARTICLES.find((a) => a.slug === slug);
